import { useLocation } from "react-use"
import queryString from "query-string"

function useQuery() {
  return queryString.parse(useLocation().search)
}

export default useQuery
